// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fv","advertDetailContacts__header":"c-m_fw"};